export enum PriceType {
  EMAIL_DOMAIN = 'email_domain',
  DND_COMPANY = 'dnd_company',
  KOST_PRICE = 'kost_price',
}
